import messages from '../locales/messages';

export default {
  legends: [
    {
      title: messages['table-firstTitle'].defaultMessage,
      type: 'multi-zone',
    },
    {
      title: messages['table-secondTitle'].defaultMessage,
      type: 'data-centers',
    },
    {
      title: messages['table-thirdTitle'].defaultMessage,
      type: 'federal-data-center',
    },
    {
      title: messages['table-fourthTitle'].defaultMessage,
      type: 'network-pop',
    },
  ],
  groups: [
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row1'].defaultMessage,
      types: [
        'data-centers',
        'network-pop',
        'federal-data-center',
        'multi-zone',
      ],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row2'].defaultMessage,
      types: [
        'network-pop',
        'data-centers',
        'federal-data-center',
        'multi-zone',
      ],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row3'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row5'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row6'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row7'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row8'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row9'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row10'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'US',
      city: messages['table-row11'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'Americas',
      country: 'CA',
      city: messages['table-row12'].defaultMessage,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'CA',
      city: messages['table-row13'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'Americas',
      country: 'BR',
      city: messages['table-row14'].defaultMessage,
      types: ['multi-zone', 'data-centers', 'network-pop'],
    },
    {
      //europe
      region: 'EMEA',
      country: 'DE',
      city: messages['table-row15'].defaultMessage,
      types: ['network-pop', 'data-centers', 'multi-zone'],
    },
    {
      region: 'EMEA',
      country: 'ES',
      city: messages['table-row16'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'EMEA',
      country: 'UK',
      city: messages['table-row17'].defaultMessage,
      types: ['network-pop', 'data-centers', 'multi-zone'],
    },
    {
      region: 'EMEA',
      country: 'FR',
      city: messages['table-row18'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'EMEA',
      country: 'NO',
      city: messages['oslo-row'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'EMEA',
      country: 'SWE',
      city: messages['stockholm-row'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'EMEA',
      country: 'NL',
      city: messages['table-row19'].defaultMessage,
      types: ['network-pop', 'data-centers'],
    },
    {
      region: 'EMEA',
      country: 'IT',
      city: messages['table-row20'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'APAC',
      country: 'JP',
      city: messages['table-row21'].defaultMessage,
      types: ['network-pop', 'multi-zone', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'JP',
      city: messages['table-row22'].defaultMessage,
      types: ['network-pop', 'multi-zone', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'GCG',
      city: messages['table-row23'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'TW',
      city: messages['table-row24'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'KR',
      city: messages['table-row25'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'SG',
      city: messages['table-row26'].defaultMessage,
      types: ['data-centers', 'network-pop'],
    },
    {
      region: 'APAC',
      country: 'IN',
      city: messages['table-row27'].defaultMessage,
      types: ['data-centers'],
    },
    {
      region: 'APAC',
      country: 'IN',
      city: messages['table-row28'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: messages['table-row29'].defaultMessage,
      types: ['multi-zone', 'network-pop', 'data-centers'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: messages['table-row30'].defaultMessage,
      types: ['network-pop'],
    },
    {
      region: 'APAC',
      country: 'AU',
      city: messages['table-row31'].defaultMessage,
      types: ['network-pop'],
    },
  ],
};
